import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Rating, Box } from '@mui/material';
import { Timestamp } from 'firebase/firestore';
import PropTypes from 'prop-types';
import { useContext, useEffect, useState } from 'react';
import { LoadingButton } from '@mui/lab';
import { fetchSession, submitSessionFeedback } from '../../services/sessions_service';
import UserContext from '../../contexts/UserContext';


FeedbackDialog.propTypes = {
    sessionId: PropTypes.object,
    onClose: PropTypes.func.isRequired,
};
export default function FeedbackDialog({ sessionId, onClose }) {
    const { user } = useContext(UserContext);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [session, setSession] = useState(null);


    const handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries(formData.entries());
        const { reason, rate } = formJson;

        setIsSubmitting(true);
        submitSessionFeedback({
            userId: user.id,
            role: 'coaches',
            sessionId,
            reason,
            rate,
            created_at: Timestamp.now(),
            updated_at: Timestamp.now(),
        })
            .then(() => {
                onClose();
            })
            .catch((error) => {
                setError(typeof error === 'string' ? error : 'An error occurred while submitting feedback.');
                console.error('Error submitting feedback:', error);
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    }

    useEffect(() => {
        if (!sessionId) return;

        setIsLoading(true);
        fetchSession(sessionId)
            .then((session) => {
                setSession(session);
            })
            .catch((error) => {
                console.error('Error fetching session:', error);
                setError('An error occurred while fetching session data.');
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [sessionId]);

    const loading = isLoading || isSubmitting;

    return (
        <Dialog
            open={Boolean(sessionId)}
            onClose={onClose}
            onSubmit={handleSubmit}
            component="form"
        >
            <DialogTitle>Give Feedback</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Thank you for giving feedback. Please rate your experience with the previous session ({isLoading ? "..." : session?.name || '-'}).
                </DialogContentText>
                <Box display="flex" justifyContent="center" alignItems="center" mb={2} mt={2}>
                    <Rating name="rate" defaultValue={2} size="large" disabled={loading} />
                </Box>
                <TextField
                    autoFocus
                    required
                    margin="dense"
                    id="name"
                    name="reason"
                    label="Reason"
                    type="text"
                    fullWidth
                    multiline
                    rows={4}
                    error={Boolean(error)}
                    helperText={error}
                    onChange={() => setError(null)}
                    disabled={loading}
                />
            </DialogContent>
            <DialogActions>
                <Button disabled={isSubmitting} onClick={onClose}>Close</Button>
                <LoadingButton disabled={loading} loading={loading} variant="contained" color="primary" type="submit">Submit</LoadingButton>
            </DialogActions>
        </Dialog>
    );
}
